import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'app-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
  imports: [ToastModule, CommonModule],
})
export class ToastMessageComponent {
  constructor(
    private router: Router
  ) {}
  
  handleNotifTap(event: any) {
    const url = event?.data?.url

    if (!url) return;
      this.router.navigateByUrl(url);
  }
}
